import { Fab, Paper } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import DatePicker from 'Components/DatePicker'
import EurestoForm from 'Components/Form'
import Input from 'Components/Input'
import Modal from 'Components/Modal'
import PhoneInput from 'Components/PhoneInput'
import Select from 'Components/Select'
import ApiRequest from 'EurestoApi/ApiRequest'
import Bus from 'EurestoClass/Bus'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents'
import EurestoDiv from 'EurestoComponents/EurestoDiv/index'
import InputClient from 'EurestoComponents/InputClient'
import Recherche from 'EurestoComponents/Recherche'
import project from 'EurestoConfig/project.config'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import moment from 'moment'
import React from 'react'
import ContactModification from '../../../CRM/Page/Modification'
import CouvertGrid from '../CouvertGrid'
import Horaire from '../Horaire'
import Couvert from '../QuantiteCouvert'
import Search from '../Search'
import Column from './Column'
import Color from 'color'

moment.locale('fr')

var h2p = require('html2plaintext')

export default (class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      key: Utils.getRandomNumber(),
      action: (User.User.get().type === 1
        || User.User.get().profil_id !== 6 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1350))) && props.type !== 'demande' ? 'add' : 'view',
      reservation: {},
      reservation_save: {},
      contact: {},
      contacts: [],
      indexSelected: undefined,
      newReservation: [],
      searchRequest: undefined
    }
    Data.addCbRestate(Constants.module.RESTAURANT, Constants.donnee.reservation, this.restate)

  }



  componentDidMount = () => {
    Bus.$on('on_search_' + (this.props.search || 'restaurant_' + (this.props.name || '') + User.Entite.get().id),
      async (search) => {
        const dateReservationSearch = search && search.length > 0 && search.find(s => s.champ === 'date_reservation') || {}
        const siteReservationSearch = search && search.length > 0 && search.find(s => s.champ === 'produit_id') || {}
        const serviceReservationSearch = search && search.length > 0 && search.find(s => s.champ === 'service_id') || {}

        let jour

        if (dateReservationSearch.valeur) {
          jour = await ApiRequest(project.api + 'restaurant', {
            requete: 'planning',
            action: 'jour',
            date: moment(dateReservationSearch.valeur, 'YYYY-MM-DD').format('YYYY-MM-DD'),
          })
        }

        if (serviceReservationSearch.valeur && serviceReservationSearch.valeur.length === 1 && dateReservationSearch.valeur && siteReservationSearch.valeur) {
          this.getReservations(dateReservationSearch.valeur, siteReservationSearch.valeur, serviceReservationSearch.valeur[0])
            .then((reservations) => {
              this.setState({
                key: Utils.getRandomNumber(),
                search: search,
                horaire: null,
                reservations: reservations && reservations.results || [],
                reservation: {
                  date_reservation: dateReservationSearch.valeur,
                  produit_id: siteReservationSearch.valeur,
                  service_id: serviceReservationSearch.valeur[0],
                },
                reservation_save: {
                  date_reservation: dateReservationSearch.valeur,
                  produit_id: siteReservationSearch.valeur,
                  service_id: serviceReservationSearch.valeur[0],
                },
                ...((jour && jour.results) ? {
                  jour: jour.results
                } : {}),
                indexSelected: undefined,
                contact: {},
                searchRequest: search,
                contacts: [],
              })
            })

          return;
        }



        this.setState({
          key: Utils.getRandomNumber(),
          search: search,
          horaire: null,
          reservation: {
            date_reservation: dateReservationSearch.valeur,
            produit_id: siteReservationSearch.valeur,
            ...(serviceReservationSearch.valeur && serviceReservationSearch.valeur.length === 1 ? { service_id: serviceReservationSearch.valeur[0] } : {}),
          },
          reservation_save: {
            date_reservation: dateReservationSearch.valeur,
            produit_id: siteReservationSearch.valeur,
            ...(serviceReservationSearch.valeur && serviceReservationSearch.valeur.length === 1 ? { service_id: serviceReservationSearch.valeur[0] } : {}),
          },
          ...((jour && jour.results) ? {
            jour: jour.results
          } : {}),
          indexSelected: undefined,
          contact: {},
          searchRequest: search,
          contacts: [],
        })
      }
    )
  }

  restate = data => {
    const newReservation = this.state.newReservation
    const { search } = this.state
    console.log(data)
    console.log(this.state.search)

    if (data.user_id === User.User.get().id) return


    const dateReservationSearch = search && search.length > 0 && search.find(s => s.champ === 'date_reservation') || null
    const siteReservationSearch = search && search.length > 0 && search.find(s => s.champ === 'produit_id') || null
    const serviceReservationSearch = search && search.length > 0 && search.find(s => s.champ === 'service_id') || null
    const niveauReservationSearch = search && search.length > 0 && search.find(s => s.champ === 'niveau' && s.operation === 'egal') || null

    if (data && data.results && data.results.length > 0) {
      if (
        niveauReservationSearch && (niveauReservationSearch.valeur.includes(0) ? (
          niveauReservationSearch.valeur.includes(data.results[0].niveau)
        ) : (niveauReservationSearch.valeur.includes(5) ? data.results[0].niveau > 0 && ![4, 5].includes(data.results[0].niveau) : data.results[0].niveau > 0 && data.results[0].niveau !== 4)) &&
        dateReservationSearch && moment(dateReservationSearch.valeur).isSame(data.results[0].date_reservation, 'date')
        && (!siteReservationSearch || data.results[0].produit_id === siteReservationSearch.valeur)
        && (!serviceReservationSearch || serviceReservationSearch.valeur.includes(data.results[0].service_id))) {
        Bus.$emit('forced_research_' + (this.props.search || 'restaurant_' + (this.props.name || '') + User.Entite.get().id))
      }
    }


    /*if (data.action === Constants.broadcastAction.add && newReservation.indexOf(data.id) === -1) {
      this.setState({
        newReservation: [
          ...newReservation,
          data.id
        ]
      })
    }*/
  }

  getContact = async search => {
    search = EurestoClone(search)
    delete search.picture
    delete search.media_id
    delete search.media_lien
    delete search.libelle
    return await ApiRequest(project.api + 'crm', {
      requete: 'client',
      action: 'list',
      limit: 5,
      offset: 0,
      recherche: Utils.searchJsonToRechercheArray(search)
    })
  }

  getReservations = async (date, produitId, serviceId) => await ApiRequest(project.api + 'restaurant', {
    requete: 'reservation',
    action: 'list',
    recherche: [
      {
        champ: 'date_reservation',
        operation: 'between',
        valeur: [date, date]
      },
      {
        champ: 'produit_id',
        operation: 'egal',
        valeur: produitId
      },
      {
        champ: 'service_id',
        operation: 'egal',
        valeur: serviceId
      },
      {
        champ: 'niveau',
        operation: 'gte',
        valeur: 0
      }
    ]
  })

  onClick = async row => {
    const produit_id = row.produit_id
    const service_id = row.service_id
    const date_reservation = moment(row.date_reservation).format('YYYY-MM-DD')
    const contact_id = row.contact_id
    let contact = {}

    if (contact_id) {
      contact = await this.getContact({
        'grc_contact.id': contact_id
      })
      contact = contact.code === 1 && contact.results.length > 0 && contact.results[0]
      contact = {
        id: contact.id,
        libelle: contact.libelle,
        qualite_id: contact.qualite_id,
        civilite_id: contact.civilite_id,
        nom: contact.nom,
        prenom: contact.prenom,
        email: contact.email,
        portable: contact.portable,
        fixe: contact.fixe,
        media_id: contact.media_id,
        media_lien: contact.media_lien,
      }
    }

    const reservations = await this.getReservations(date_reservation, produit_id, service_id)

    const historiques = await ApiRequest(project.api + 'restaurant', {
      requete: 'reservation',
      action: 'list',
      recherche: [
        {
          champ: 'contact_id',
          operation: 'egal',
          valeur: contact_id
        },
      ]
    })

    const jour = (await ApiRequest(project.api + 'restaurant', {
      requete: 'planning',
      action: 'jour',
      date: moment(row.date_reservation).format('YYYY-MM-DD')
    }))

    this.setState({
      action: 'view',
      reservations: reservations.results,
      horaire: moment(row.date_reservation).format("HH:mm"),
      reservation: EurestoClone(row),
      reservation_save: EurestoClone(row),
      contact_save: EurestoClone(contact),
      contact: contact,
      key: Utils.getRandomNumber(),
      historiques: historiques.results,
      jour: jour.results,
      defaultSearch: {
        'contact_id': contact_id
      },
    })
  }

  historique = (reservations, color, old = false) => <Grid key={color + '_' + reservations.length + '-niveau-historique'} container
    justify={'center'}
    alignItems={'center'}
    onClick={this.handleToggleModal(true, reservations)}
    style={{
      cursor: 'pointer',
      margin: 2,
      border: '1px solid black',
      borderRadius: '50%',
      height: 25,
      width: 25,
      fontSize: 14,
      background: color,
      color: old ? 'black' : (Color(color).isDark() ? 'white' : 'black'),
    }}>{reservations.length}</Grid>

  handleToggleModal = (view = false, modalData = []) => _ => {
    this.setState({ showModalHistorique: view, modalData: modalData })
  }

  handleToggleModalContact = (view = false) => _ => {
    this.setState({ showModalContact: view })
  }

  changeLevelResa = (niveau) => async _ => {
    const { reservation } = this.state


    const day = this.state.jour.find(j => j.service_id === this.state.reservation.service_id && j.produit_id === this.state.reservation.produit_id)

    if (day) {
      if (day.gestion_limite_couverts > 0 && [1, 2, 3].includes(niveau)) {
        if (day.couverts_non_reserves < this.state.reservation.quantite) {
          User.NotificationSystem.callback({
            message: 'Vous ne pouvez enregistrer cette réservation. Nombre limite de couverts dépassé. Vous n\'avez plus que ' + day.couverts_non_reserves + ' couverts disponible.',
            variant: 'error',
          })
          return;
        }
      }
    }

    await ApiRequest(project.api + 'restaurant', {
      requete: 'reservation',
      action: 'niveau',
      id: this.state.reservation.id,
      niveau: niveau
    })
    reservation.niveau = niveau
    this.setState({ reservation, key: Utils.getRandomNumber() })
  }

  renotifier = _ => {
    ApiRequest(project.api + 'restaurant', {
      requete: 'reservation',
      action: 'notify',
      id: this.state.reservation.id,
    })
  }

  action = (reservation) => moment(reservation.date_reservation, 'YYYY-MM-DD HH:mm').isAfter() &&
    <div style={{ display: 'inline-block' }}><Grid container
      justify={'space-around'}
      alignContent={'center'}>
      {reservation.niveau === 0 &&
        <React.Fragment>
          <Button style={{ marginRight: 5, padding: '0px 10px' }} variant="contained" color={'primary'}
            onClick={this.changeLevelResa(3)}>Accepter</Button>
          <Button style={{ marginRight: 5, padding: '0px 10px' }} variant="contained"
            className={'EurestoError EurestoText--text'}
            onClick={this.changeLevelResa(4)}>Refuser</Button>
        </React.Fragment>
        ||
        reservation.niveau <= 3 && reservation.niveau > 0 && <React.Fragment>
          <Tooltip disableTouchListener placement="bottom-start" title={'Renvoyer une notification par mail et/ou sms'}><Button
            style={{ marginRight: 5, padding: '0px 10px' }} variant="contained"
            color={'primary'} onClick={this.renotifier}>Re-notifier</Button></Tooltip>
          {
            reservation.niveau === 3 && <Button style={{ marginRight: 5, padding: '0px 10px' }} variant="contained"
              className={'EurestoError EurestoText--text'}
              onClick={this.changeLevelResa(5)}>Annuler</Button>
          }
        </React.Fragment>}
    </Grid>
    </div>

  onChangeState = async (data, name) => {
    let { reservation, reservations, contact, historiques, contact_save } = this.state
    let jour = this.state.jour

    if (reservation.date_reservation && name === 'date_reservation') {
      data = moment(data, 'YYYY-MM-DD').format('YYYY-MM-DD ' + moment(reservation.date_reservation, 'YYYY-MM-DD HH:mm').format('HH:mm'))
    }

    if (Data.list(Constants.module.RESTAURANT, Constants.donnee.produit).length === 1) {
      reservation.produit_id = Data.list(Constants.module.RESTAURANT, Constants.donnee.produit)[0].id
    }

    reservation[name] = data

    if (name === 'produit_id') {
      reservation.service_id = null
      reservation.horaire = null
      reservation.date_reservation = moment(reservation.date_reservation, 'YYYY-MM-DD').format('YYYY-MM-DD ')
    }

    if (name === 'service_id') {
      reservation.horaire = null
      reservation.date_reservation = moment(reservation.date_reservation, 'YYYY-MM-DD').format('YYYY-MM-DD ')
    }

    if (name === 'niveau' && data !== 1) {
      delete reservation.date_option
    }

    if (name === 'date_reservation') {
      jour = (await ApiRequest(project.api + 'restaurant', {
        requete: 'planning',
        action: 'jour',
        date: moment(data, 'YYYY-MM-DD').format('YYYY-MM-DD'),
      })).results
    }

    if (name === 'contact_id' && data > 0) {
      contact = await this.getContact({
        'grc_contact.id': data
      })
      contact = contact.code === 1 && contact.results.length > 0 && contact.results[0] || contact
      contact = {
        id: contact.id,
        libelle: contact.libelle,
        qualite_id: contact.qualite_id,
        civilite_id: contact.civilite_id,
        nom: contact.nom,
        prenom: contact.prenom,
        email: contact.email,
        portable: contact.portable,
        fixe: contact.fixe,
        media_id: contact.media_id,
        media_lien: contact.media_lien,
      }
      contact_save = EurestoClone(contact)
      historiques = (await ApiRequest(project.api + 'restaurant', {
        requete: 'reservation',
        action: 'list',
        recherche: [
          {
            champ: 'contact_id',
            operation: 'egal',
            valeur: data
          },
        ]
      })).results
    }

    if (reservation.date_reservation && reservation.produit_id && reservation.service_id &&
      (name === 'date_reservation' || name === 'produit_id' || name === 'service_id')) {
      reservations = (await this.getReservations(moment(reservation.date_reservation, 'YYYY-MM-DD').format('YYYY-MM-DD'), reservation.produit_id, reservation.service_id)).results
    }

    this.setState({
      reservations: reservations,
      reservation: reservation,
      jour: jour,
      contact: contact,
      contact_save: contact_save,
      historiques: historiques,
      ...(["service_id", "produit_id"].includes(name) ? { horaire: null } : {})
    })
  }

  onChangeHeureReservation = (heure) => _ => {
    const reservation = this.state.reservation
    reservation.date_reservation = moment(reservation.date_reservation, 'YYYY-MM-DD').format('YYYY-MM-DD ' + heure)
    this.setState({
      horaire: heure,
      reservation: reservation,
    })
  }

  searchClient = async (data, name) => {
    const contact = this.state.contact

    if (name === 'picture') {
      contact.media_id = data.id
      contact.media_lien = data.media_lien
    } else {
      contact[name] = data
    }
    const contacts = await this.getContact(contact)

    this.setState({
      //contact_save: EurestoClone(contact),
      contact: contact,
      contacts: contacts.results || []
    })
  }

  form = (disabled, autoFocus) => {
    const { reservations, reservation } = this.state
    let horaires = []
    let jourProduitService = {}
    let quantiteMaxService = undefined
    console.log("##############reservation##############", reservation)
    if (reservation.produit_id && reservation.service_id) {
      jourProduitService = (this.state.jour || []).find(j => j.produit_id === reservation.produit_id && j.service_id === reservation.service_id) || {}
      console.log(jourProduitService)
      if (Object.keys(jourProduitService).length > 0) {
        horaires = jourProduitService.horaires
        quantiteMaxService = jourProduitService.quantite_couverts_max
      } else {
        jourProduitService.reservation_couverts_max = Data.get(Constants.module.RESTAURANT, Constants.donnee.produit, { id: reservation.produit_id }).reservation_couverts_max || 20
        quantiteMaxService = Data.get(Constants.module.RESTAURANT, Constants.donnee.produit, { id: reservation.produit_id }).quantite_couverts_max || 20
        horaires = Data.get(Constants.module.RESTAURANT, Constants.donnee.service, { id: reservation.service_id }).horaires.map(horaire => ({
          heure: horaire,
          fermee: moment().isAfter(reservation.date_reservation) && 1
        }))
      }
    }
    const heure = moment(reservation.date_reservation, 'YYYY-MM-DD HH:mm').format('HH:mm')
    const couverts = horaires && reservation.date_reservation && horaires.find(horaire => horaire.heure === heure) || []

    let libelleCivilite = ''
    if (this.state.contact && this.state.contact.civilite_id !== undefined && this.state.contact.civilite_id !== null) {
      const civiliteFound = Data.get(Constants.module.COMMUN, Constants.donnee.civilite, { id: this.state.contact.civilite_id })
      libelleCivilite = civiliteFound.abrege
    }

    const reservationAccepted = (this.state.historiques || []).filter(r => r.niveau > 0 && r.niveau <= 3)
    const reservationRefused = (this.state.historiques || []).filter(r => r.niveau === 4)
    const reservationCanceled = (this.state.historiques || []).filter(r => r.niveau === 5)
    const reservationRequested = (this.state.historiques || []).filter(r => r.niveau === 0 && moment(r.date_reservation, 'YYYY-MM-DD HH:mm').isAfter(moment()))
    const reservationOldRequested = (this.state.historiques || []).filter(r => r.niveau === 0 && moment(r.date_reservation, 'YYYY-MM-DD HH:mm').isSameOrBefore(moment()))

    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 5, height: '100%', overflow: 'auto' }} spacing={0}
        direction="column"
        justify={'space-between'}
        wrap={"nowrap"}
        alignItems="stretch">
        <Grid container>
          <Grid container>
            <Grid item xs={12} md={6}>
              <DatePicker disabled={disabled}
                clearDate={false}
                value={reservation.date_reservation}
                title={EurestoI18n.t('crm:Date de réservation')}
                name={'date_reservation'}
                disablePast={this.state.action === 'add'}
                disableDate={this.state.action === 'add' && []}
                onChange={this.onChangeState} />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={6}>
              <Select
                inputProps={{ style: { textAlign: 'center' } }}
                title={EurestoI18n.t('commun:Niveau')}
                name="niveau"
                default={2}
                disabled={disabled}
                options={[
                  (this.props.type === 'demande' && {
                    disabled: true,
                    label: 'Demande',
                    value: 0,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(0, moment().add(1, 'year')),
                      color: 'black',
                    }} />
                  } || {}),
                  {
                    label: 'Option',
                    value: 1,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(1),
                      color: Color(Utils.reservationColor(1)).isDark() ? 'white' : 'black',
                    }} />
                  },
                  {
                    label: 'En Attente',
                    value: 2,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(2),
                      color: Color(Utils.reservationColor(2)).isDark() ? 'white' : 'black',
                    }} />
                  },
                  {
                    label: 'Confirmée',
                    value: 3,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(3),
                      color: Color(Utils.reservationColor(3)).isDark() ? 'white' : 'black',
                    }} />
                  },
                  (this.props.type === 'demande' && {
                    label: 'Refusée',
                    value: 4,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(4),
                      color: Color(Utils.reservationColor(4)).isDark() ? 'white' : 'black',
                    }} />
                  } || {}),
                  {
                    label: 'Annulée',
                    value: 5,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(5),
                      color: Color(Utils.reservationColor(5)).isDark() ? 'white' : 'black',
                    }} />
                  },
                  {
                    label: 'ARRIVE',
                    value: 6,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(6),
                      color: Color(Utils.reservationColor(6)).isDark() ? 'white' : 'black',
                    }} />
                  },
                  {
                    label: 'PLACE',
                    value: 7,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(7),
                      color: Color(Utils.reservationColor(7)).isDark() ? 'white' : 'black',
                    }} />
                  },
                  {
                    label: 'PARTI',
                    value: 8,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(8),
                      color: Color(Utils.reservationColor(8)).isDark() ? 'white' : 'black',
                    }} />
                  },
                  {
                    label: 'NO-SHOW',
                    value: 9,
                    startAdornment: <Grid item style={{
                      borderRadius: '50%',
                      border: '1px solid black',
                      width: 15,
                      height: 15,
                      background: Utils.reservationColor(9),
                      color: Color(Utils.reservationColor(9)).isDark() ? 'white' : 'black',
                    }} />
                  }
                ]}
                value={reservation.niveau} onChange={this.onChangeState} />
            </Grid>
            <Grid item xs={12} md={6}>
              {reservation.niveau === 1 &&
                <DatePicker disabled={disabled}
                  title={EurestoI18n.t(`crm:Date d'option`)}
                  value={reservation.date_option}
                  name={'date_option'}
                  disablePast={this.state.action === 'add'}
                  maxDate={reservation.date_reservation}
                  onChange={this.onChangeState} />}

              {reservation.niveau === 5 &&
                <Grid item xs={12} md={6}>
                  <DataComponent disabled={disabled}
                    key={reservation.produit_id}
                    title={EurestoI18n.t('crm:Motif Annulation')}
                    name="motif_id"
                    type={Constants.typeSaisie.ComboSimple}
                    onChange={this.onChangeState}
                    data={reservation.motif_id}
                    object={Constants.donnee.motif_annulation}
                    module={Constants.module.RESTAURANT}
                    search={{ actif: 1 }}
                  />
                </Grid>}
              {reservation.niveau === 4 &&
                <Grid item xs={12} md={6}>
                  <DataComponent disabled={disabled}
                    key={reservation.produit_id}
                    title={EurestoI18n.t('crm:Motif Refus')}
                    name="motif_id"
                    type={Constants.typeSaisie.ComboSimple}
                    onChange={this.onChangeState}
                    data={reservation.motif_id}
                    object={Constants.donnee.motif_refus}
                    module={Constants.module.RESTAURANT}
                    search={{ actif: 1 }}
                  />
                </Grid>}
            </Grid>
          </Grid>
          {reservation.date_reservation && <Grid container>
            {Data.list(Constants.module.RESTAURANT, Constants.donnee.produit).length > 1 && <Grid item xs={12} md={6}>
              <DataComponent disabled={disabled}
                title={EurestoI18n.t('crm:Restaurant')}
                name="produit_id"
                type={Constants.typeSaisie.ComboSimple}
                onChange={this.onChangeState}
                data={reservation.produit_id}
                object={Constants.donnee.produit}
                module={Constants.module.RESTAURANT}
              />
            </Grid>}
            <Grid item xs={12} md={6}>
              {reservation.produit_id && <DataComponent disabled={disabled}
                key={reservation.produit_id}
                title={EurestoI18n.t('crm:Service')}
                name="service_id"
                type={Constants.typeSaisie.ComboSimple}
                onChange={this.onChangeState}
                data={reservation.service_id}
                object={Constants.donnee.service}
                module={Constants.module.RESTAURANT}
                search={{ produit_id: reservation.produit_id }}
              />}
            </Grid>
          </Grid>}
          {reservation.produit_id && reservation.service_id &&
            <Grid container spacing={8} justify={'center'} alignItems={'center'} alignContent={'center'}>
              {
                jourProduitService.description && h2p(jourProduitService.description) &&
                <Grid item xs={12}>
                  <Grid item container direction={'column'} alignItems={'stretch'}
                    className={'EurestoPrimary EurestoText--text'}
                    style={{ borderRadius: 5, padding: '5px 10px', marginBottom: 5 }}>
                    <div dangerouslySetInnerHTML={{ __html: jourProduitService.description }} />
                  </Grid>
                </Grid>
              }
              <Grid item xs>
                <Grid container direction={'column'} alignItems={'stretch'}>
                  {
                    (jourProduitService.fermeture > 0 || jourProduitService.complet > 0) && <Grid container direction={'column'} alignItems={'stretch'}
                      className={'EurestoError EurestoText--text'}
                      style={{ borderRadius: 5, padding: '5px 10px', marginBottom: 5 }}>
                      {jourProduitService.fermeture === 1 && 'Fermé' || jourProduitService.complet === 1 && 'Complet' || 'Fermé à la réservation'}
                    </Grid>
                  }
                  <Horaire value={heure} disabled={disabled} horaires={horaires}
                    onChange={this.onChangeHeureReservation} />
                  <Couvert max={(((this.state.action === 'view' || this.state.action === 'update') && reservation.id) ? this.state.reservation_save.quantite : 0) + (jourProduitService.reservation_couverts_max || 0)}
                    value={reservation.quantite}
                    couverts={couverts}
                    disabled={disabled}
                    onChange={this.onChangeState} />
                </Grid>
              </Grid>

              {
                <Grid item xs={12} md={12} lg={12} style={{ padding: 5 }}>
                  <Input multi rowsMax={7} rows={7} value={reservation.commentaire}
                    disabled={disabled}
                    onChange={this.onChangeState} name={'commentaire'} title={'Commentaire'} />
                </Grid>}
            </Grid>}

          {(reservation.niveau === 4 || reservation.niveau === 5) &&
            reservation.motif_id &&
            (Data.get(Constants.module.RESTAURANT, reservation.niveau === 5 ? Constants.donnee.motif_annulation : Constants.donnee.motif_refus, { id: reservation.motif_id }) || {}).description_complementaire
            &&
            <Grid item xs={12} md={5} lg={4} style={{ padding: 5 }}>
              <Input multi rowsMax={7} rows={7} value={reservation.motif}
                disabled={disabled}
                onChange={this.onChangeState} name={'motif'} title={'Motif de refus'} />
            </Grid>
          }

          <InputClient disabled={disabled} ajoutContact={true} contact_id={reservation.contact_id} onChange={this.onChangeState} />
          <Paper style={{ marginBottom: 5 }}>
            <form noValidate autoComplete="off">
            <Grid container justify={'flex-start'} alignItems={'center'} spacing={0}>
              <Grid item style={{ padding: 5 }}>
                <Grid container style={{ position: 'relative' }} direction={'column'} justify={'flex-start'}
                  alignItems={'center'} spacing={0}>
                  {this.state.contact && this.state.contact.id && <Fab className={'EurestoSecondary--text EurestoPrimary'}
                    size={'small'}
                    onClick={this.handleToggleModalContact(true)}
                    style={{ top: -5, left: -5, position: 'absolute' }}>
                    <i className={'ei-commun_user_2'}
                      style={{ fontSize: 16 }} />
                  </Fab>}
                  <DataComponent onChange={this.searchClient}
                    name='picture'
                    avatarStyle={{
                      borderRadius: 10,
                      maxWidth: 100,
                      maxHeight: 100
                    }}
                    style={{
                      height: 100
                    }}
                    disabled={disabled}
                    type={Constants.typeSaisie.Picture}
                    defineData
                    data={{
                      id: this.state.contact.media_id,
                      lien: this.state.contact.media_lien
                    }}
                    object={{
                      picture: {
                        id: this.state.contact.media_id,
                        lien: this.state.contact.media_lien
                      },
                    }} />
                </Grid>
              </Grid>
              <Grid item xs style={{ padding: 5 }}>
                <Grid container spacing={8} justify={'flex-start'}>
                    <Grid item sm={12} md={12} lg={6} style={{ paddingRight: 5 }}>
                    <DataComponent disabled={disabled}
                      inline
                      onChange={this.searchClient}
                      title={EurestoI18n.t('crm:Civilité')}
                      key={reservation.contact_id + '_civilite_id'}
                      name="civilite_id"
                      data={this.state.contact.civilite_id}
                      type={Constants.typeSaisie.ComboSimple}
                      object={Constants.donnee.civilite}
                      module={Constants.module.COMMUN}
                      search={{ type: 1 }}
                    />
                  </Grid>
                    <Grid item sm={12} md={12} lg={6} style={{ paddingRight: 5 }}>
                    <DataComponent disabled={disabled}
                      inline
                      onChange={this.searchClient}
                      title={EurestoI18n.t('crm:Qualité')}
                      key={reservation.contact_id + '_qualite_id'}
                      name="qualite_id"
                      data={this.state.contact.qualite_id}
                      type={Constants.typeSaisie.ComboSimple}
                      object={Constants.donnee.qualite}
                      module={Constants.module.CRM}
                    />
                  </Grid>
                    <Grid item sm={12} md={12} lg={6} style={{ paddingRight: 5 }}>
                    <Select disabled={disabled}
                      inline
                      title={'Nom'}
                      onChangeText={this.searchClient}
                      add
                      key={reservation.contact_id + '_nom'}
                      options={(this.state.contacts || []).map(contact => ({
                        label: contact.nom || '',
                        value: contact.id,
                        html: <span><strong>{contact.nom}</strong> {contact.prenom}</span>
                      }))}
                      onChange={this.onChangeState}
                      name={'contact_id'}
                      nameText={'nom'}
                        autocomplete='off'
                      text={this.state.contact.nom}
                      value={reservation.contact_id}
                    />
                  </Grid>
                    <Grid item sm={12} md={12} lg={6} style={{ paddingRight: 5 }}>
                    <Select disabled={disabled}
                      inline
                      title={'Prénom'}
                      onChangeText={this.searchClient}
                      add
                      key={reservation.contact_id + '_prenom'}
                      options={(this.state.contacts || []).map(contact => ({
                        label: contact.prenom || '',
                        value: contact.id,
                        html: <span>{contact.nom} <strong>{contact.prenom}</strong></span>
                      }))}
                      onChange={this.onChangeState}
                      name={'contact_id'}
                      nameText={'prenom'}
                      text={this.state.contact.prenom}
                      value={reservation.contact_id} />
                  </Grid>
                    <Grid item sm={12} md={12} lg={9} xl={6} style={{ paddingRight: 5 }}>
                    <Select disabled={disabled}
                      inline
                      title={'Email'}
                      onChangeText={this.searchClient}
                      add
                      key={reservation.contact_id + '_email'}
                      options={(this.state.contacts || []).map(contact => ({
                        label: contact.email || '',
                        value: contact.id,
                        html: <span>{contact.nom} {contact.prenom}<strong> {contact.email}</strong></span>
                      }))}
                      onChange={this.onChangeState}
                      name={'contact_id'}
                      nameText={'email'}
                      text={this.state.contact.email}
                      value={reservation.contact_id} />
                  </Grid>
                    <Grid item sm={12} md={12} lg={9} xl={6} style={{ paddingRight: 5 }}>
                    {reservation.contact_id === undefined &&
                      <Select disabled={disabled}
                        title={'Fixe'}
                        inline
                        onChangeText={this.searchClient}
                        add
                        key={reservation.contact_id + '_fixe'}
                        options={(this.state.contacts || []).map(contact => ({
                          label: contact.fixe || '',
                          value: contact.id,
                          html:
                            <span>{contact.nom} {contact.prenom}<strong> {contact.fixe}</strong></span>
                        }))}
                        onChange={this.onChangeState}
                        name={'contact_id'}
                        nameText={'fixe'}
                        text={this.state.contact.fixe}
                        value={reservation.contact_id} /> ||

                      <PhoneInput title={'Fixe'} value={this.state.contact.fixe}
                        inline
                        onChange={this.searchClient} name={'fixe'} />}
                  </Grid>
                    <Grid item sm={12} md={12} lg={9} xl={6} style={{ paddingRight: 5 }}>
                    {reservation.contact_id === undefined &&
                      <Select disabled={disabled}
                        title={'Portable'}
                        inline
                        onChangeText={this.searchClient}
                        add
                        key={reservation.contact_id + '_portable'}
                        options={(this.state.contacts || []).map(contact => ({
                          label: contact.portable || '',
                          value: contact.id,
                          html:
                            <span>{contact.nom} {contact.prenom}<strong> {contact.portable}</strong></span>
                        }))}
                        onChange={this.onChangeState}
                        name={'contact_id'}
                        nameText={'portable'}
                        text={this.state.contact.portable}
                        value={reservation.contact_id} /> ||

                      <PhoneInput title={'Portable'} value={this.state.contact.portable}
                        inline
                        onChange={this.searchClient} name={'portable'} />}
                  </Grid>
                </Grid>
              </Grid>
              {reservation.contact_id > 0 &&
                <Grid container justify={'flex-start'} alignItems={'flex-start'} direction={'column'}>
                  <Grid container justify={'flex-start'} alignItems={'flex-start'} direction={'column'}>
                    <Grid container alignContent={'center'} alignItems={'center'} justify={'space-between'}
                      style={{ width: '100%', padding: 10 }}>
                      <Grid item xs>
                        <span
                          style={{ fontSize: 15 }}>
                          Historique des <a className={'cursor-pointer'}
                            style={{ color: 'blue', textDecoration: 'underline' }}
                            onClick={this.handleToggleModal(true, this.state.historiques)}>
                            {(this.state.historiques || []).length}
                          </a> réservation(s) de {libelleCivilite} {this.state.contact.libelle} : </span>
                      </Grid>
                      <Grid item>
                        <Grid container alignContent={'space-between'} justify={'space-around'}>
                          {
                            this.historique(reservationAccepted, Utils.reservationColor(3))
                          }
                          {
                            this.historique(reservationRefused, Utils.reservationColor(4))
                          }
                          {
                            this.historique(reservationCanceled, Utils.reservationColor(5))
                          }
                          {this.historique(reservationRequested, Utils.reservationColor(0, moment().add(1, 'year').format('YYYY-MM-DD')))}
                            {this.historique(reservationOldRequested, Utils.reservationColor(0, moment('1993-08-02').format('YYYY-MM-DD')), true)}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>}
              </Grid>
            </form>
          </Paper>
        </Grid>
        <CouvertGrid reservation={reservation || {}} reservations={reservations || []}
          quantiteMaxService={quantiteMaxService}
          key={reservation && reservations && ('reservation_' + reservation.id + '_' + (reservations || []).length) || Utils.getRandomNumber()}
          onClick={this.handleToggleModal} />
      </Grid >
    )
  }

  onCancel = (action = 'add', reset = true) => {
    console.log('I cancel it, NO ?')
    this.setState({
      key: Utils.getRandomNumber(),
      action: action,
      horaire: null,
      ...(reset ? {
        reservation: action !== 'add' ? (this.state.reservation_save) : {
        date_reservation: (this.state.reservation || {}).date_reservation,
        produit_id: (this.state.reservation || {}).produit_id,
        service_id: (this.state.reservation || {}).service_id,
        }
      } : {}),
      contact: action !== 'add' ? this.state.contact : {},
    }, _ => action !== 'add' && this.state.reservation && this.onClick(this.state.reservation))
  }

  onSave = async (action) => {
    const contact = EurestoClone(this.state.contact, (k, v) => v === undefined ? null : v)

    if (this.state.reservation.contact_id > 0) {
      if (Object.keys(contact).map(key => contact[key] !== this.state.contact_save[key]).reduce((a, b) => a || b, false)) {
        const contactSave = await ApiRequest(project.api + 'crm', {
          requete: 'client',
          action: 'get',
          id: this.state.reservation.contact_id
        })

        await ApiRequest(project.api + 'crm', {
          requete: 'client',
          action: 'update',
          ...contactSave.results,
          ...contact,
          id: this.state.reservation.contact_id
        }, { showAlertError: false })
      }
    } else {
      const contactAdd = await ApiRequest(project.api + 'crm', {
        requete: 'client',
        action: 'add',
        ...contact
      }, { showAlertError: false })
      if (contactAdd) {
        this.state.reservation.contact_id = contactAdd.id
      }
    }

    const day = this.state.jour.find(j => j.service_id === this.state.reservation.service_id && j.produit_id === this.state.reservation.produit_id)
    console.log(day, this.state.jour, this.state.reservation)
    if (!this.state.horaire) {
      User.NotificationSystem.callback({
        message: 'Vous ne pouvez enregistrer cette réservation. Veuillez saisir une heure d\'arrivée.',
        variant: 'error',
      })
      return;
    }
    if (day) {
      if (day.gestion_limite_couverts > 0 && (!this.state.reservation.niveau || [1, 2, 3].includes(this.state.reservation.niveau))) {

        if (action === 'update') {
          if (this.state.reservation.quantite !== this.state.reservation_save.quantite) {
            if (day.couverts_non_reserves < (this.state.reservation.quantite - this.state.reservation_save.quantite)) {
              User.NotificationSystem.callback({
                message: 'Vous ne pouvez enregistrer cette réservation. Nombre limite de couverts dépassé. Vous n\'avez plus que ' + day.couverts_non_reserves + ' couverts disponible.',
                variant: 'error',
              })
              return;
            }
          }
        } else {
          if (day.couverts_non_reserves < this.state.reservation.quantite) {
            User.NotificationSystem.callback({
              message: 'Vous ne pouvez enregistrer cette réservation. Nombre limite de couverts dépassé. Vous n\'avez plus que ' + day.couverts_non_reserves + ' couverts disponible.',
              variant: 'error',
            })
            return;
          }
        }
      }
    }


    delete this.state.reservation.date_debut
    delete this.state.reservation.jour_debut
    delete this.state.reservation.date_fin
    delete this.state.reservation.jour_fin

    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'reservation',
      action: action === 'update' ? 'update' : 'add',
      niveau: 2,
      ...this.state.reservation
    })
    if (result.code === 1) {
      Bus.$emit('forced_research_' + (this.props.search || 'restaurant_' + (this.props.name || '') + User.Entite.get().id))
      this.onCancel('view', false)
    }
  }

  onView = (action) => {
    this.onCancel('view')
  }

  onClickNewReservation = _ => {
    Bus.$emit('forced_search_' + (this.props.search || 'restaurant_' + (this.props.name || '') + User.Entite.get().id),
      { 'id': this.state.newReservation }
    )
    this.setState({
      newReservation: []
    })
  }

  render() {
    const { reservation } = this.state

    let libelleCivilite = ''
    if (reservation && reservation.civilite_id !== undefined && reservation.civilite_id !== null && reservation.entite === 1) {
      const civiliteFound = Data.get(Constants.module.COMMUN, Constants.donnee.civilite, { id: reservation.civilite_id })
      libelleCivilite = civiliteFound.abrege
    }

    console.log('"#########R2SAAAAAAAAA#######', reservation)

    return (
      <EurestoDiv title={
        <Grid container justify={'center'} alignItems={'center'} alignContent={'center'}>
          Réservations
          {
            this.state.newReservation.length > 0 &&
            this.state.newReservation.length > 0 &&
            <Fab color={'default'}
              onClick={this.onClickNewReservation}
              size="small"
              container
              justify={'center'}
              alignContent={'center'}
              alignItems={'center'}
              style={{ marginLeft: 7.5 }}
              className={'EurestoText--text EurestoError cursor-pointer'}>{this.state.newReservation.length}</Fab>
          }
        </Grid>}>
        <Grid container justify={'center'} style={{
          position: 'relative',
          height: User.CalculHeight.getHeightWanted(50),
          ...(this.props.paperProps && this.props.paperProps.style || {})
        }}>
          <Grid item xs={this.props.hideForm !== true && 7 || 12}>
            <Recherche
              hideSearch={this.props.hideSearch}
              showSearch={this.props.showSearch}
              searchComponent={<Search
                type={this.props.type}
                name={this.props.name}
                defaultSearch={this.props.defaultSearch}
                searchProps={this.props.searchProps || {}}
                search={this.props.search || 'restaurant_' + (this.props.name || '') + User.Entite.get().id} />}
              selected={this.state.reservation}
              view={'list'}
              style={{
                height: User.CalculHeight.getHeightWanted(50),
                maxHeight: User.CalculHeight.getHeightWanted(50),
                ...(this.props.style || {})
              }}
              type={this.props.type}
              onClick={this.onClick}
              columns={Column(this.props.withUser !== undefined ? this.props.withUser : true, this.props.type !== 'reservation')}
              search={this.props.search || 'restaurant_' + (this.props.name || '') + User.Entite.get().id}
            />
          </Grid>
          {this.props.hideForm !== true && <Grid item xs={5} style={{ height: '100%' }}>
            {reservation &&
              <Grid container justify={'space-between'} style={{ height: '100%' }} alignItems={'stretch'}
                direction={'column'}>
                <EurestoForm key={this.state.key}
                  borderLeft
                  showTab={false}
                  style={{ padding: 0 }}
                  libelle={'Réservation pour le ' + moment(reservation.date_reservation, 'YYYY-MM-DD HH:mm').format('dddd DD MMMM YYYY à HH:mm')}
                  action={this.state.action}
                  isAllow={
                    User.User.get().type === 1 || User.User.get().profil_id !== 6 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1350)) ? {
                      delete: false,
                      update: this.props.type !== 'demande' && reservation.niveau > 0 && moment(reservation.date_reservation, 'YYYY-MM-DD HH:mm').isAfter(),
                      add: this.props.type !== 'demande',
                      archive: false,
                      unarchive: false,
                      cancel: true,
                      duplicate: this.props.type !== 'demande'
                    } : {
                      delete: false,
                      update: false,
                      add: false,
                      archive: false,
                      unarchive: false,
                      cancel: false,
                      duplicate: false
                    }
                  }
                  onSave={this.onSave}
                  onCancel={this.onCancel}
                  onView={this.onView}
                  buttons={[
                    ...(User.User.get().type === 1 || User.User.get().profil_id !== 6 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1350)) ? [
                      {
                        title: 'Re-notifier',
                        className: 'EurestoSecondary--text',
                        icon: ' ei-commun_ajouter',
                        cb: this.renotifier,
                        isAllow: reservation.niveau <= 5 && reservation.niveau > 0 && this.state.action === 'view'
                      }, {
                      title: 'Confirmer',
                      className: 'EurestoSecondary--text',
                      icon: ' ei-commun_valider',
                      cb: this.changeLevelResa(3),
                      isAllow: reservation.niveau === 0 && this.state.action === 'view'
                    },
                    {
                      title: 'Refuser',
                      className: 'EurestoSecondary--text',
                      icon: ' ei-commun_supprimer',
                      cb: _ => this.setState({
                        action: 'update',
                        horaire: moment(reservation.date_reservation).format("HH:mm"),
                        reservation: {
                          ...reservation,
                          niveau: 4
                        },
                        key: Utils.getRandomNumber(),
                      }),
                      isAllow: reservation.niveau === 0 && this.state.action === 'view'
                      }] : [])
                  ]}
                  libelleAdd={EurestoI18n.t('commun:Nouvelle réservation')}
                  children={this.form} />
              </Grid>}
          </Grid>}
          <Modal key={this.state.showModalHistorique + '_modal'} open={this.state.showModalHistorique}
            onClose={this.handleToggleModal()}>
            <EurestoDiv
              paddingTopBody={0}
              fromModal={true}
              title={reservation && (this.state.showModalHistorique === 'jour' && ('Agenda des réservations du ' +
                moment(reservation.date_reservation, 'YYYY-MM-DD').format('dddd DD MMMM YYYY') + ' [' +
                (Data.get(Constants.module.RESTAURANT, Constants.donnee.produit, { id: reservation.produit_id }) || {}).libelle
                + ' - ' +
                (Data.get(Constants.module.RESTAURANT, Constants.donnee.service, { id: reservation.service_id }) || {}).libelle + ']')
                || ('Historique des réservation(s) de ' + (libelleCivilite && (libelleCivilite + ' ')) + reservation.libelle_contact))}
              style={{
                margin: 0,
                padding: 0
              }}
              buttonsRight={[{
                icon: ' ei-commun_fermer',
                className: 'EurestoError--text EurestoText',
                cb: this.handleToggleModal()
              }]}>
              <Recherche
                key={'grid_historique_' + this.state.key}
                view={'list'}
                type={this.props.type}
                data={(this.state.modalData || [])}
                columns={Column()}
                style={{
                  maxHeight: 400
                }}
              />
            </EurestoDiv>
          </Modal>
          <Modal key={this.state.showModalContact + '_modal'}
            open={this.state.showModalContact}
            grid={{
              xs: 12
            }}
            onClose={this.handleToggleModalContact()}>
            <EurestoDiv
              paddingTopBody={0}
              fromModal={true}
              title={EurestoI18n.t('commun:Fiche Contact')}
              style={{
                margin: 0,
                padding: 0
              }}
              buttonsRight={[{
                icon: ' ei-commun_fermer',
                className: 'EurestoError--text EurestoText',
                cb: this.handleToggleModalContact()
              }]}>
              <ContactModification params={{ id: this.state.contact.id }} />
            </EurestoDiv>
          </Modal>
        </Grid>
      </EurestoDiv>
    )
  }

})



// WEBPACK FOOTER //
// ./app/App/Module/Restaurant/Component/Demande/index.js